import { gql } from '@apollo/client';

export const GetSchoolNumbersQuery = gql`
    query GetSchoolNumbers($locationId: ID, $regionId: ID) {
        getSchoolNumbers(locationId: $locationId, regionId: $regionId)
    }
`;
